export interface User {
  active: boolean;
  auth_method: string;
  coins_balance: number;
  coins_total: number;
  country: string;
  created_at: number;
  currency: string;
  email: string;
  first_name: string;
  flags: number;
  gender: string;
  id: number;
  ip_address: string;
  language: string;
  last_accessed_at: number;
  last_name: string;
  last_notified_at: number;
  locale: string;
  monetized_coins_total: number;
  monetized_completions_count: number;
  name: string;
  payout_total: number;
  payout_total_usd: number;
  paypal_email: string;
  phone_country_code: string;
  phone_iso_code: string;
  phone_number: string;
  picture: string;
  referral_code: string;
  referrals_coins_total: number;
  referrals_count: number;
  referrer_coins_total: number;
  referrer_id: number;
  revenue_total_usd: number;
  time_zone: string;
  time_zone_offset: number;
  updated_at: number;
  verification_status: string;
  nick_name: string;
}

export function createUser(user: User): User {
  return {
    active: user.active,
    auth_method: user.auth_method,
    coins_balance: user.coins_balance,
    coins_total: user.coins_total,
    country: user.country,
    created_at: user.created_at,
    currency: user.currency,
    email: user.email,
    first_name: user.first_name,
    flags: user.flags,
    gender: user.gender,
    id: user.id,
    ip_address: user.ip_address,
    language: user.language,
    last_accessed_at: user.last_accessed_at,
    last_name: user.last_name,
    last_notified_at: user.last_notified_at,
    locale: user.locale,
    monetized_coins_total: user.monetized_coins_total,
    monetized_completions_count: user.monetized_completions_count,
    name: user.name,
    payout_total: user.payout_total,
    payout_total_usd: user.payout_total_usd,
    paypal_email: user.paypal_email,
    phone_country_code: user.phone_country_code,
    phone_iso_code: user.phone_iso_code,
    phone_number: user.phone_number,
    picture: user.picture,
    referral_code: user.referral_code,
    referrals_coins_total: user.referrals_coins_total,
    referrals_count: user.referrals_count,
    referrer_coins_total: user.referrer_coins_total,
    referrer_id: user.referrer_id,
    revenue_total_usd: user.revenue_total_usd,
    time_zone: user.time_zone,
    time_zone_offset: user.time_zone_offset,
    updated_at: user.updated_at,
    verification_status: user.verification_status,
    nick_name: user.nick_name,
  };
}